import { Navigate, Route, Routes } from "react-router";
import { Toaster } from "sonner";

import { AdminRoute, ProtectedRoute } from "@/components/protected-route";
import { AdminActivityPage } from "@/features/admin/activity";
import { AdminTracksPage } from "@/features/admin/tracks";
import { AdminUsersPage } from "@/features/admin/users";
import { DashboardPage } from "@/features/dashboard";
import { HomePage } from "@/features/home";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { ProfilePage } from "@/features/profile";
import { SignupPage } from "@/features/signup";
import { TrackDetailPage } from "@/features/tracks/track-detail";
import { VerifyEmailPage } from "@/features/verify-email";

export function App() {
  return (
    <>
      <Toaster richColors position="top-right" />
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/home" element={<HomePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/tracks/:id" element={<TrackDetailPage />} />
        </Route>
        <Route element={<AdminRoute />}>
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/activity" element={<AdminActivityPage />} />
          <Route path="/admin/tracks" element={<AdminTracksPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
